import React from 'react';
import {Modal, ModalHeader} from 'reactstrap';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import CardBox from "components/CardBox";

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import FolderIcon from '@material-ui/icons/Folder';
//import DeleteIcon from '@material-ui/icons/Delete';
import VideoLibrary from '@material-ui/icons/VideoLibrary'
import LibraryMusic from '@material-ui/icons/LibraryMusic'
import PermMedia from '@material-ui/icons/PermMedia'
import { envConfig } from '../../../environment';
import TaleAttachmentPreview from './TaleAttachementPreview';
import { gettaleAbstractByTaleIdApi } from '../../../api/taleAbstract';
import { downlaodFileApi } from '../../../api/upload';
import { formatCompilerBirthDate, formatComplationDate } from '../../../util/utilFunction';
//import SpellcheckIcon from '@material-ui/icons/Spellcheck';


class PreviewTaleModal extends React.Component {
  constructor(props) {
    super(props);

    const {sourceType,compilerExplanation, area,city, taleName,taleSource, taleText,  taleSourceText,   actionId ,  numberOfWord,  compilerNameSurname,  compilerJob,   whereToCompile, sourcePerson ,uploadList, compilerPlaceOfBirth,  compilerBirthDate, compilerEducationLevel,copyrightStatus , subGroupName } = this.props.tale;

    this.state = {
      compilerExplanation,
      sourceType,
      copyrightStatus,
        area,city, taleName,taleSource, taleText,
        taleSourceText,
        actionId ,
        numberOfWord,
        compilerNameSurname,
        compilerJob,
        whereToCompile,
         sourcePerson,
         uploadList,
         compilerPlaceOfBirth,
         compilerBirthDate,
         compilerEducationLevel,
         selectedItem : {},
         taleAttachmentPreviewState :false,
         taleAbstractList:[]
    }
  }

  componentWillReceiveProps =  async(nextProps) => {
 //   console.log("props: ",nextProps)
    const {taleId,sourceType,uploadList, taleTextEnd, area,city, taleName,taleSource, taleText,  taleSourceText,   actionId ,  numberOfWord,  compilerNameSurname,  compilerJob,   whereToCompile, sourcePerson  ,compilerPlaceOfBirth,
      compilerBirthDate,subGroupName,
      compilerEducationLevel, groupName,groupId,contextProperties ,copyrightStatus,compilerExplanation} = nextProps.tale;
      let taleAbstractList = [];
      if(taleId !== undefined)
        taleAbstractList =  await gettaleAbstractByTaleIdApi(taleId);
///console.log("contextProperties",contextProperties);
    this.setState( {uploadList,sourceType, area,city, taleName,taleSource, taleText,  taleSourceText,   actionId ,  numberOfWord,  compilerNameSurname,  compilerJob,   whereToCompile, sourcePerson ,  compilerPlaceOfBirth,
      compilerBirthDate,subGroupName,
      compilerEducationLevel,groupName,groupId,taleAbstractList,contextProperties ,copyrightStatus,compilerExplanation}) ;

  }

  componentDidMount = async() => {
    //   console.log("props: ",nextProps)
       const {taleId,sourceType,uploadList,subGroupName,taleTextEnd, area,city, taleName,taleSource, taleText,  taleSourceText,   actionId ,  numberOfWord,  compilerNameSurname,  compilerJob,   whereToCompile, sourcePerson  ,compilerPlaceOfBirth,
         compilerBirthDate,
         compilerEducationLevel, groupName,groupId,contextProperties ,copyrightStatus,compilerExplanation} = this.props.tale;
         let taleAbstractList = [];
         if(taleId !== undefined)
           taleAbstractList =  await gettaleAbstractByTaleIdApi(taleId);
   ///console.log("contextProperties",contextProperties);
       this.setState( {uploadList,sourceType, subGroupName,taleTextEnd, area,city, taleName,taleSource, taleText,  taleSourceText,   actionId ,  numberOfWord,  compilerNameSurname,  compilerJob,   whereToCompile, sourcePerson ,  compilerPlaceOfBirth,
         compilerBirthDate,
         compilerEducationLevel,groupName,groupId,taleAbstractList,contextProperties ,copyrightStatus,compilerExplanation}) ;
   
     }
    
  downloadFile = (filePath)=>{

    setTimeout(()=>{
      const response = {
        file : filePath,
      };
      window.open(response.file);
    },100);
  }

  download_file(fileURL, fileName) {
    // for non-IE
    if (!window.ActiveXObject) {
        var save = document.createElement('a');
        save.href = fileURL;
        save.target = '_blank';
        var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
        save.download = fileName || filename;
	       if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
				document.location = save.href; 
// window event not working here
			}else{
		        var evt = new MouseEvent('click', {
		            'view': window,
		            'bubbles': true,
		            'cancelable': false
		        });
		        save.dispatchEvent(evt);
		        (window.URL || window.webkitURL).revokeObjectURL(save.href);
			}	
    }

    // for IE < 11
    else if ( !! window.ActiveXObject && document.execCommand)     {
        var _window = window.open(fileURL, '_blank');
        _window.document.close();
        _window.document.execCommand('SaveAs', true, fileName || fileURL)
        _window.close();
    }
}

  downloadFile2 = async(filePath,fileName)=>{

   // downlaodFileApi(filePath,fileName);
   // await downlaodFileApi(filePath,fileName)
   setTimeout(()=>{
    const response = {
      file : filePath,
      fileName
    };
    const link = document.createElement('a');
          link.href = filePath;
      //    link.target = "_blank"
          link.download = fileName;
        //  link.setAttribute('download', fileName); //or any other extension
          document.body.appendChild(link);

          link.click();
          document.body.removeChild(link)

  },100);

  }
  render() {
    const { onModalClose, open} = this.props;
    const {uploadList,sourceType, area,city, taleName,taleSource, taleText,  taleSourceText,    
       compilerNameSurname,  compilerJob,   whereToCompile,taleTextEnd, sourcePerson, subGroupName,
        compilerPlaceOfBirth,  compilerBirthDate, compilerEducationLevel,groupName  ,groupId,contextProperties,copyrightStatus,compilerExplanation} = this.state;
//console.log("render talesource ",taleSource)
    let uploadList1= [];
    uploadList1.push(...uploadList);
    return (

    

      <Modal className="modal-box" size="lg" fullwidth isOpen={open} >
        <ModalHeader className="modal-box-header bg-primary text-white">
       Önizleme
          <IconButton className="text-white"
                      onClick={onModalClose}>
            <CloseIcon/>
          </IconButton>
        </ModalHeader>

        <div className="modal-box-content modal-lg">
          <div className="row">
          <CardBox styleName="col-lg-12 col-md-12 col-12" heading={"Masal Bilgileri"}>
             <div className="row">
             <div className="col-md-6 col-12">

                        <div className="media flex-nowrap mt-3">
                            <div className="mr-3">
                            <i className={`zmdi zmdi-dns jr-fs-xlxl text-orange`}/>
                            </div>
                            <div className="media-body">
                            <h6 className="mb-1 text-grey">Masal Adı</h6>
                    
                            {taleName === '' ? null : <p className="mb-0">{taleName}</p>}
                            </div>
                        </div>

                </div>
                <div className="col-md-3 col-12">

                        <div className="media flex-nowrap mt-3">
                            <div className="mr-3">
                            <i className={`zmdi zmdi-copy jr-fs-xlxl text-orange`}/>
                            </div>
                            <div className="media-body">
                            <h6 className="mb-1 text-grey">Telif</h6>
                    
                            {taleName === '' ? null : <p className="mb-0">{copyrightStatus===1 ? "İstiyorum":"İstemiyorum"}</p>}
                            </div>
                        </div>

                </div>
                <div className="col-md-3 col-12">

                            <div className="media flex-nowrap mt-3">
                                <div className="mr-3">
                                <i className={`zmdi zmdi-shape jr-fs-xlxl text-orange`}/>
                                </div>
                                <div className="media-body">
                                <h6 className="mb-1 text-grey">Masal Türü</h6>

                                {(groupName === null) || (groupId === 0) ? "Editör Tarafından Girilecek" : <p className="mb-0">{groupName + (subGroupName !== "" ? ' / ' + subGroupName : "")}</p>}
                                </div>
                            </div>

                            </div>
             </div>   
             <div className="row">
           
             <div className="col-md-4">
                                    <div className="media flex-nowrap mt-3">
                                        <div className="mr-3">
                                        <i className={`zmdi zmdi-map jr-fs-xlxl text-orange`}/>
                                        </div>
                                        <div className="media-body">
                                        <h6 className="mb-1 text-grey">Bölge</h6>

                                        {area === '' ? null : <p className="mb-0">{area}</p>}
                                        </div>
                             </div>    
                            </div>
                            <div className="col-md-4">
                                    <div className="media flex-nowrap mt-3">
                                        <div className="mr-3">
                                        <i className={`zmdi zmdi-city jr-fs-xlxl text-orange`}/>
                                        </div>
                                        <div className="media-body">
                                        <h6 className="mb-1 text-grey">Şehir</h6>

                                        {city === '' ? null : <p className="mb-0">{city}</p>}
                                        </div>
                          

                                    </div>
                            </div>
                            <div className="col-md-4">
                                    <div className="media flex-nowrap mt-3">
                                        <div className="mr-3">
                                        <i className={`zmdi zmdi-rss jr-fs-xlxl text-orange`}/>
                                        </div>
                                        <div className="media-body">
                                        <h6 className="mb-1 text-grey">Masal Kaynağı</h6>

                                        {taleSource === 1 || taleSource === "1" ? <p className="mb-0">Derleme</p> : <p className="mb-0">Tez / Basılı Yayın</p>}
                                        </div>
                             </div>    
                            </div>
</div>
             <div className="row"></div>
         
        

          </CardBox>

          <CardBox styleName="col-lg-12 col-md-12 col-12" heading={"Derleyici Bilgileri"}>
           
             <div className="row">
           
             <div className="col-md-4">
                                    <div className="media flex-nowrap mt-3">
                                        <div className="mr-3">
                                        <i className={`zmdi zmdi-account-o jr-fs-xlxl text-orange`}/>
                                        </div>
                                        <div className="media-body">
                                        <h6 className="mb-1 text-grey">Derleyen Adı Soyadı</h6>

                                        {compilerNameSurname === '' ? null : <p className="mb-0">{compilerNameSurname}</p>}
                                        </div>
                             </div>    
                            </div>
                            <div className="col-md-4">
                                    <div className="media flex-nowrap mt-3">
                                        <div className="mr-3">
                                        <i className={`zmdi zmdi-roller jr-fs-xlxl text-orange`}/>
                                        </div>
                                        <div className="media-body">
                                        <h6 className="mb-1 text-grey">Derleyici Mesleği</h6>

                                        {compilerJob === '' ? null : <p className="mb-0">{compilerJob}</p>}
                                        </div>
                          

                                    </div>
                            </div>
                            <div className="col-md-4">
                                    <div className="media flex-nowrap mt-3">
                                        <div className="mr-3">
                                        <i className={`zmdi zmdi-grain jr-fs-xlxl text-orange`}/>
                                        </div>
                                        <div className="media-body">
                                        <h6 className="mb-1 text-grey">Nereden Derlediği</h6>

                                        {whereToCompile === '' ? null : <p className="mb-0">{whereToCompile}</p>}
                                        </div>
                             </div>    
                            </div>
</div>
          
         
            

<div className="row">
         
         <div className="col-md-4">
                     <div className="media flex-nowrap mt-3">
                         <div className="mr-3">
                         <i className={`zmdi zmdi-graduation-cap jr-fs-xlxl text-orange`}/>
                         </div>
                         <div className="media-body">
                         <h6 className="mb-1 text-grey">Eğitim Seviyesi</h6>

                         {compilerEducationLevel === '' ? null : <p className="mb-0">{compilerEducationLevel}</p>}
                         </div>
              </div>    
             </div>
             <div className="col-md-4">
                     <div className="media flex-nowrap mt-3">
                         <div className="mr-3">
                         <i className={`zmdi zmdi-cake jr-fs-xlxl text-orange`}/>
                         </div>
                         <div className="media-body">
                         <h6 className="mb-1 text-grey">Doğum tarihi</h6>

                         {compilerBirthDate === '' ? null : <p className="mb-0">{formatCompilerBirthDate(compilerBirthDate)}</p>}
                         </div>
           

                     </div>
             </div>
             <div className="col-md-4">
                     <div className="media flex-nowrap mt-3">
                         <div className="mr-3">
                         <i className={`zmdi zmdi-pin jr-fs-xlxl text-orange`}/>
                         </div>
                         <div className="media-body">
                         <h6 className="mb-1 text-grey">Doğum yeri</h6>

                         {compilerPlaceOfBirth === '' ? null : <p className="mb-0">{compilerPlaceOfBirth}</p>}
                         </div>
              </div>    
             </div>
             
</div>









          </CardBox>
          {compilerExplanation !== "" ? 
            <CardBox styleName="col-lg-12 col-md-12 col-12" heading={"Derleyici Açıklamaları"}>
            <div className="row"> 
   <div className="col-md-12">
                       <div className="media flex-nowrap mt-3">
                           <div className="mr-3">
                           <i className={`zmdi zmdi-album jr-fs-xlxl text-orange`}/>
                           </div>
                           <div className="media-body">
                           <h6 className="mb-1 text-grey">Derleyici Notu </h6>
  
                          {compilerExplanation}
                           </div>
                </div>    
               </div>
               </div> 
              </CardBox> : null
        
        }
        

          <CardBox styleName="col-lg-12 col-md-12 col-12" heading={"Kaynak Bilgileri"}>
           
           <div className="row">
         
           <div className={sourceType === 0 ? "col-md-4" : "col-md-8"}>
                                  <div className="media flex-nowrap mt-3">
                                      <div className="mr-3">
                                      <i className={`zmdi zmdi-account-o jr-fs-xlxl text-orange`}/>
                                      </div>
                                      <div className="media-body">
                                      <h6 className="mb-1 text-grey">{sourceType === 0 ? "Adı Soyadı" : "Materyal Adı"}</h6>

                                      {sourcePerson.nameSurname === '' ? null : <p className="mb-0">{sourcePerson.nameSurname}</p>}
                                      </div>
                           </div>    
                          </div>
                          <div className="col-md-4">
                                <div className="media flex-nowrap mt-3">
                                    <div className="mr-3">
                                    <i className={`zmdi zmdi-calendar-note jr-fs-xlxl text-orange`}/>
                                    </div>
                                    <div className="media-body">
                                    <h6 className="mb-1 text-grey">Derleme Tarihi</h6>

                                    <p className="mb-0">{formatComplationDate(sourcePerson.complationDate)}</p>
                                    </div>
                         </div>    
                        </div>
                        {sourceType === 0 ? 
                          <div className="col-md-4">
                                  <div className="media flex-nowrap mt-3">
                                      <div className="mr-3">
                                      <i className={`zmdi zmdi-pin jr-fs-xlxl text-orange`}/>
                                      </div>
                                      <div className="media-body">
                                      <h6 className="mb-1 text-grey">Nereden Öğrendiği</h6>

                                      {sourcePerson.learnedFrom === '' ? null : <p className="mb-0">{sourcePerson.learnedFrom}</p>}
                                      </div>
                           </div>    
                          </div> : null }
</div>
        
{sourceType === 0 ? <div className="row">
                       <div className="col-md-3">
                                  <div className="media flex-nowrap mt-3">
                                      <div className="mr-3">
                                      <i className={`zmdi zmdi-roller jr-fs-xlxl text-orange`}/>
                                      </div>
                                      <div className="media-body">
                                      <h6 className="mb-1 text-grey">Mesleği</h6>

                                      {sourcePerson.job === '' ? null : <p className="mb-0">{sourcePerson.job}</p>}
                                      </div>
                        

                                  </div>
                          </div>
                    <div className="col-md-3">
                                <div className="media flex-nowrap mt-3">
                                    <div className="mr-3">
                                    <i className={`zmdi zmdi-graduation-cap jr-fs-xlxl text-orange`}/>
                                    </div>
                                    <div className="media-body">
                                    <h6 className="mb-1 text-grey">Eğitim Seviyesi</h6>

                                    {sourcePerson.educationLevel === '' ? null : <p className="mb-0">{sourcePerson.educationLevel}</p>}
                                    </div>
                         </div>    
                        </div>
                        <div className="col-md-3">
                                <div className="media flex-nowrap mt-3">
                                    <div className="mr-3">
                                    <i className={`zmdi zmdi-cake jr-fs-xlxl text-orange`}/>
                                    </div>
                                    <div className="media-body">
                                    <h6 className="mb-1 text-grey">Doğum Yılı</h6>

                                    {sourcePerson.birthDate === '' ? null : <p className="mb-0">{sourcePerson.birthDate}</p>}
                                    </div>
                      

                                </div>
                        </div>
                        <div className="col-md-3">
                                <div className="media flex-nowrap mt-3">
                                    <div className="mr-3">
                                    <i className={`zmdi zmdi-looks jr-fs-xlxl text-orange`}/>
                                    </div>
                                    <div className="media-body">
                                    <h6 className="mb-1 text-grey">Doğum Yeri</h6>

                                    {sourcePerson.placeOfBirth === '' ? null : <p className="mb-0">{sourcePerson.placeOfBirth}</p>}
                                    </div>
                         </div>    
                        </div>
                       
</div>
:null}

        </CardBox>
          
          {uploadList1.length>0 ?
          <CardBox styleName="col-lg-12 col-md-12 col-12" heading={"Masal Ek Dosyaları"}>
 

          <List dense={false}>
                  {uploadList1.map( item => 
                    <ListItem button key={item.id} >
                      <ListItemIcon>
                       {item.type === 1 ?<PermMedia/> : item.type===2 ? <LibraryMusic/> : item.type===3 ? <VideoLibrary/> : <FolderIcon/>}
                      </ListItemIcon>
                      <ListItemText 
                        primary={item.fileName}
                         secondary= {item.type === 1 ? "Resim" : item.type===2 ? "Ses Dosyası" : item.type===3 ? "Video" : "Diğer"}
                      
                     />
                       <ListItemIcon>
                         {
                           item.type===3 || item.type===2 ? 
                         
                           <Button variant="contained" color="secondary" className="jr-btn jr-btn-label right" onClick={()=>{
                             this.setState({selectedItem:item , taleAttachmentPreviewState:true})
                           }}>
                              {
                           item.type===3  ? [<i className="zmdi zmdi-videocam zmdi-hc-fw "/>,<span>İzle</span> ] : 
                            item.type===2 ? [<i className="zmdi zmdi-audio zmdi-hc-fw "/>,<span>Dinle</span> ] : null}
                                </Button>
                           : null
                         }
                     <Button variant="contained" color="primary" className="jr-btn jr-btn-label right" 
                     onClick={()=> this.downloadFile2(envConfig.apiUrl + item.filePath,item.fileName)}>İndir</Button>
                      {/* <DeleteIcon onClick={()=> this.deleteFile(item)}/> */}
                    </ListItemIcon>
                    </ListItem>
                   
                  
                    
                  )}
                </List>
  
                <TaleAttachmentPreview item={this.state.selectedItem} open={this.state.taleAttachmentPreviewState} handleRequestClose={()=>this.setState({taleAttachmentPreviewState:false})} />
          </CardBox>
          :
          null  
        }
{/*       
      {taleAbstractList.length>0 ? <CardBox styleName="col-lg-12 col-md-12 col-12" heading={"Öz Bilgisi"}>
      <div className="row">
       
       <List className="list bg-light" color="primary" dense={true} fullWidth maxWidth="xl"  >
        {taleAbstractList.map(item =>
          <ListItem button key={item.taleAbstractId}>
             <ListItemIcon>
                <SpellcheckIcon/>          
              </ListItemIcon>
            <ListItemText inset={true} primary={item.abstractText}/>
            <ListItemIcon>
                      </ListItemIcon>
          </ListItem>,
        )}
        
      </List>

       </div>
</CardBox> : null} */}


        <CardBox styleName="col-lg-12 col-md-12 col-12" heading={"Ana Masal Metni"}>
          <div dangerouslySetInnerHTML={{ __html: taleText }}></div>  
        </CardBox>

        <CardBox styleName="col-lg-12 col-md-12 col-12" heading={"Yayınlanacak Masal Metni"}>
          <div dangerouslySetInnerHTML={{ __html: taleTextEnd }}></div>  
        </CardBox>

        {taleSource === "2" ?  
        <CardBox styleName="col-lg-12 col-md-12 col-12" heading={"Kaynakça"}>
          <div dangerouslySetInnerHTML={{ __html: taleSourceText }}></div>  
        </CardBox> : null }
        {contextProperties !== '' && contextProperties !== null   ? <CardBox styleName="col-lg-12 col-md-12 col-12" heading={"Bağlam Özellikleri"}>
      <div className="row">
      
                              <div className="col-md-12 col-12">

                                                <div className="media flex-nowrap mt-3">
                                                    <div className="mr-3">
                                                    <i className={`zmdi zmdi-image jr-fs-xlxl text-orange`}/>
                                                    </div>
                                                    <div className="media-body">
                                                    <h6 className="mb-1 text-grey">Bağlam Özellikleri:</h6>

                                                  <p className="mb-0">{contextProperties}</p>
                                                    </div>
                                                </div>

                        </div>

       </div>
</CardBox> : null}
          </div>
        </div>

        <div className="modal-box-footer d-flex flex-row">
          <Button  variant="contained" color="primary" onClick={onModalClose}>Kapat</Button>
        </div>
      </Modal>
    );
  }
}

export default PreviewTaleModal;